import { fork, all } from "redux-saga/effects";
import formActionSaga from "redux-form-saga";
import filesSaga from "./files";

export default function* rootSaga() {
  yield all([fork(filesSaga), fork(formActionSaga)]);
}
